import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { LangProvider } from "./contexts/LangContext";
import BackofficeRoute from "./components/BackofficeRoute";
import DeveloperRoute from "./components/DeveloperRoute";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import BlogPost from "./pages/BlogPost";
import AdminLogin from "./pages/AdminLogin";
import BackofficeDashboard from "./pages/BackofficeDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import DeveloperDashboard from "./pages/DeveloperDashboard";
import DeveloperSettings from "./pages/DeveloperSettings";
import PageNotFound from "./pages/PageNotFound";

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="bottom-right" richColors closeButton />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/login" element={<AdminLogin />} />
            <Route path="/backoffice/login" element={<AdminLogin />} />
            <Route
              path="/backoffice"
              element={
                <BackofficeRoute>
                  <BackofficeDashboard />
                </BackofficeRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/developer"
              element={
                <DeveloperRoute>
                  <DeveloperDashboard />
                </DeveloperRoute>
              }
            />
            <Route
              path="/developer/settings"
              element={
                <DeveloperRoute>
                  <DeveloperSettings />
                </DeveloperRoute>
              }
            />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
